var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.17,1.5h7.65a3.83,3.83,0,0,1,3.83,3.83v9.57a1.91,1.91,0,0,1-1.91,1.91H6.26a1.91,1.91,0,0,1-1.91-1.91V5.33A3.83,3.83,0,0,1,8.17,1.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.17,
    y1: 16.8,
    x2: 5.3,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 16.8,
    x2: 18.7,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.26,
    y1: 20.63,
    x2: 17.74,
    y2: 20.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.65,
    y1: 11.07,
    x2: 4.35,
    y2: 11.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.22,
    y1: 13.93,
    x2: 9.13,
    y2: 13.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.87,
    y1: 13.93,
    x2: 16.78,
    y2: 13.93
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/Train.c991065e93de34e5a3322f85cc2ce5a1.svg";
export { ForwardRef as ReactComponent };